import type { Recipe } from '@/types';
import { time } from '@/time';

const recipe: Recipe = {
  title: 'BBQ Sauce',
  source: 'https://www.seriouseats.com/sous-vide-pork-ribs-recipe-food-lab',
  totalTime: time(0, 25),
  servings: 4,
  tags: { type: 'sauce' },
  ingredients: [
    { name: 'BBQ pork rub', quantity: '3', unit: 'tbsp',
      recipe: 'bbq-pork-rub',
    },
    { name: 'yellow onion', quantity: '1',
      note: 'medium, grated',
    },
    { name: 'ketchup', quantity: '1 1/2', unit: 'cup' },
    { name: 'spicy brown mustard', quantity: '2', unit: 'tbsp' },
    { name: 'dark molasses', quantity: '1/3', unit: 'cup' },
    { name: 'Worcestershire sauce', quantity: '1/4', unit: 'cup' },
    { name: 'apple cider vinegar', quantity: '1/4', unit: 'cup' },
    { name: 'liquid hickory smoke', quantity: '3/4', unit: 'tsp' },
  ],
  directions: [
    {
      title: 'Simmer sauce',
      bullets: [
        "In medium saucepan, whisk together {BBQ pork rub}, {yellow onion}, {ketchup}, {spicy brown mustard}, {dark molasses}, {Worcestershire sauce}, {apple cider vinegar} & {liquid hickory smoke}",
        "Bring to bare simmer",
        "Cook ~20 min until reduced & thickened",
      ],
    },
  ],
};

export default recipe;
